import { SiteMetric, SiteTypeItem } from './types'
import { DriveStatistics, SiteStatistics } from '../../../../dataSources/queries'
import {
  FILTER_STATUS_KEY,
  ON_LEGAL_HOLD,
  URL_DRIVES,
  URL_SITES,
  YesNoFilterValues
} from '../../../../../constants'
import { IntlShape } from 'react-intl'

export const driveMockData: DriveStatistics = {
  totalDrives: 100,
  activeDrives: 80,
  inactiveDrives: 20,
  orphanedDrives: 100,
  drivesOnLegalHold: 200
}

export const siteMockData: SiteStatistics = {
  totalSites: 100,
  activeSites: 80,
  archivedSites: 20,
  inactiveSites: 20,
  orphanedSites: 20,
  sitesOnLegalHold: 20
}

// Build metrics based on datasource type
export const siteMetrics = (
  intl: IntlShape,
  isOneDrive: boolean,
  driveStatistics: DriveStatistics,
  siteStatistics: SiteStatistics
): SiteMetric[] => {
  return isOneDrive
    ? [
        {
          count: intl.formatNumber(driveStatistics?.totalDrives || 0, { notation: 'compact' }),
          label: intl.formatMessage({ id: 'siteOverview.metrics.totalDrives' }),
          iconColor: '#6366F1',
          bgColor: '#EAE7FD',
          link: URL_DRIVES
        },
        {
          count: intl.formatNumber(driveStatistics?.activeDrives || 0, { notation: 'compact' }),
          label: intl.formatMessage({ id: 'siteOverview.metrics.activeDrives' }),
          iconColor: '#84CC16',
          bgColor: '#F2FFE0',
          link: URL_DRIVES
        }
      ]
    : [
        {
          count: intl.formatNumber(siteStatistics?.totalSites || 0, { notation: 'compact' }),
          label: intl.formatMessage({ id: 'siteOverview.metrics.totalSites' }),
          iconColor: '#6366F1',
          bgColor: '#EAE7FD',
          link: URL_SITES
        },
        {
          count: intl.formatNumber(siteStatistics?.activeSites || 0, { notation: 'compact' }),
          label: intl.formatMessage({ id: 'siteOverview.metrics.activeSites' }),
          iconColor: '#84CC16',
          bgColor: '#F2FFE0',
          link: URL_SITES,
          queryParam: {
            [FILTER_STATUS_KEY]: 'Active'
          }
        },
        {
          count: intl.formatNumber(siteStatistics?.archivedSites || 0, { notation: 'compact' }),
          label: intl.formatMessage({ id: 'siteOverview.metrics.archivedSites' }),
          iconColor: '#6B7280',
          bgColor: '#ECEEF1',
          link: URL_SITES,
          queryParam: {
            [FILTER_STATUS_KEY]: 'Archived'
          }
        }
      ]
}
// Build site types based on datasource type
export const siteTypes = (
  intl: IntlShape,
  isOneDrive: boolean,
  driveStatistics: DriveStatistics,
  siteStatistics: SiteStatistics
): SiteTypeItem[] => {
  return isOneDrive
    ? [
        {
          count: intl.formatNumber(driveStatistics?.inactiveDrives || 0, { notation: 'compact' }),
          label: intl.formatMessage({ id: 'siteOverview.types.unlicensed' }),
          borderColor: '#6B7280',
          link: URL_DRIVES
        },
        {
          count: intl.formatNumber(driveStatistics?.drivesOnLegalHold || 0, {
            notation: 'compact'
          }),
          label: intl.formatMessage({ id: 'siteOverview.types.drivesOnLegalHold' }),
          borderColor: '#EF4444',
          link: URL_DRIVES
        }
      ]
    : [
        {
          count: intl.formatNumber(siteStatistics?.orphanedSites || 0, { notation: 'compact' }),
          label: intl.formatMessage({ id: 'siteOverview.types.orphanedSites' }),
          borderColor: '#F59E0B',
          link: URL_SITES,
          queryParam: {
            [FILTER_STATUS_KEY]: 'Orphaned'
          }
        },
        {
          count: intl.formatNumber(siteStatistics?.inactiveSites || 0, { notation: 'compact' }),
          label: intl.formatMessage({ id: 'siteOverview.types.inactiveSites' }),
          borderColor: '#6B7280',
          link: URL_SITES,
          queryParam: {
            [FILTER_STATUS_KEY]: 'Suspended'
          }
        },
        {
          count: intl.formatNumber(siteStatistics?.sitesOnLegalHold || 0, { notation: 'compact' }),
          label: intl.formatMessage({ id: 'siteOverview.types.sitesOnLegalHold' }),
          borderColor: '#EF4444',
          link: URL_SITES,
          queryParam: {
            [ON_LEGAL_HOLD]: YesNoFilterValues.yes
          }
        }
      ]
}
